import React from "react";
import { Col, Row } from "reactstrap";
import axios from "axios";
import { post, postJsonRaw, put, putJsonRaw } from "../../helpers/api_helper";
import { uri } from "../../helpers/api_helper";
import * as api from "../../constants/api_constants";
import { showErrorToast, showSuccessToast } from "../../helpers/toastMessages";
import Signature from "../../assets/images/Sign.png";
import CertificateLayout from "../../assets/images/certificateLogos/CertificateLayout.svg";
import { jsPDF } from "jspdf";
import html2canvas from "html2canvas";
import { CustomButton } from "components/CommonInputs/CustomButtons/CustomButton";
import { useNavigate } from "react-router-dom";

const CertificatePreview = ({ submittedData, certificateId }) => {
  console.log("CertificatePreview received submittedData:", submittedData);
  const navigate = useNavigate();

  const formatDate = (dateString) => {
    if (!dateString) return "";
    return new Date(dateString).toLocaleDateString("en-US", {
      year: "numeric",
      month: "long",
      day: "numeric",
    });
  };

  const getCertificateDetails = (data, type) => {
    console.log("getCertificateDetails data:", data, "type:", type);
    if (!data || !type) {
      return {
        title: "Certificate",
        description: (
          <span>[Description will be populated after filling the form]</span>
        ),
      };
    }

    switch (type) {
      case "internship":
        return {
          title: "of Internship",
          description: (
            <>
              This is to certify that{" "}
              <span className="font-bold" style={{ fontWeight: "bold" }}>
                '{data.recipientName || "[Recipient's Name]"}'
              </span>{" "}
              has successfully completed the{" "}
              <span className="font-bold" style={{ fontWeight: "bold" }}>
                '{data.courseType || "[Course Type]"}'
              </span>{" "}
              internship program at{" "}
              <span className="font-bold" style={{ fontWeight: "bold" }}>
                '{data.companyName || "Elbert Technology"}'
              </span>{" "}
              from{" "}
              <span className="font-bold" style={{ fontWeight: "bold" }}>
                {formatDate(data.startDate)}
              </span>{" "}
              to{" "}
              <span className="font-bold" style={{ fontWeight: "bold" }}>
                {formatDate(data.endDate)}
              </span>
              , with a duration of{" "}
              <span className="font-bold" style={{ fontWeight: "bold" }}>
                {data.duration || "[Duration]"}
              </span>{" "}
              days. During this period, he/she demonstrated exceptional
              dedication, a strong work ethic, and a keen willingness to learn,
              contributing significantly to ongoing projects and organizational
              goals. We commend his/her professionalism and innovative approach,
              which reflect the core values of our organization.
            </>
          ),
        };
      case "appreciation":
      case "achievement":
        return {
          title: `of ${
            type === "appreciation" ? "Appreciation" : "Achievement"
          }`,
          description: (
            <>
              This is to certify that{" "}
              <span className="font-bold" style={{ fontWeight: "bold" }}>
                '{data.recipientName || "[Recipient's Name]"}'
              </span>{" "}
              has been recognized for outstanding contributions in the{" "}
              <span className="font-bold" style={{ fontWeight: "bold" }}>
                {data.dept || "[Department]"}
              </span>{" "}
              department at{" "}
              <span className="font-bold" style={{ fontWeight: "bold" }}>
                '{data.companyName || "Elbert Technology"}'
              </span>{" "}
              on{" "}
              <span className="font-bold" style={{ fontWeight: "bold" }}>
                {formatDate(data.issueDate)}
              </span>
              . Your dedication and excellence have significantly impacted our
              organization.
            </>
          ),
        };
      case "hackathon_winner":
        return {
          title: "of Hackathon Victory",
          description: (
            <>
              This certifies that{" "}
              <span className="font-bold" style={{ fontWeight: "bold" }}>
                {data.recipientName || "[Recipient's Name]"}
              </span>{" "}
              has emerged as the winner of the{" "}
              <span className="font-bold" style={{ fontWeight: "bold" }}>
                {data.hackathonName || "[Hackathon Name]"}
              </span>{" "}
              organized by{" "}
              <span className="font-bold" style={{ fontWeight: "bold" }}>
                {data.companyName || "Elbert Technology "}
              </span>{" "}
              on{" "}
              <span className="font-bold" style={{ fontWeight: "bold" }}>
                {formatDate(data.issueDate)}
              </span>
              . Through exemplary problem-solving skills, creativity, and
              technical expertise, you demonstrated outstanding innovation and
              mastery, setting a benchmark for excellence. We celebrate this
              remarkable achievement and look forward to witnessing further
              groundbreaking accomplishments.
            </>
          ),
        };

      case "hackathon_participation":
        return {
          title: "of Hackathon Participation",
          description: (
            <>
              This is to acknowledge that{" "}
              <span className="font-bold" style={{ fontWeight: "bold" }}>
                {data.recipientName || "[Recipient's Name]"}
              </span>{" "}
              participated actively in the{" "}
              <span className="font-bold" style={{ fontWeight: "bold" }}>
                Hackathon
              </span>{" "}
              Organized by{" "}
              <span className="font-bold" style={{ fontWeight: "bold" }}>
                {data.companyName || "Elbert Technology "}
              </span>{" "}
              at{" "}
              <span className="font-bold" style={{ fontWeight: "bold" }}>
                Anurag Engineering College, Kodad
              </span>
              <br />
              We appreciate [his/her/their] enthusiasm, collaborative spirit,
              and commitment to innovation displayed throughout the event.
            </>
          ),
        };

      case "best_team":
        return {
          title: "of Best Team",
          description: (
            <>
              This is to certify that the team{" "}
              <span className="font-bold" style={{ fontWeight: "bold" }}>
                "{data.teamName || "[Team Name]"}"
              </span>{" "}
              has been recognized as the Best Team by{" "}
              <span className="font-bold" style={{ fontWeight: "bold" }}>
                '{data.companyName || "Elbert Technology"}'
              </span>{" "}
              on{" "}
              <span className="font-bold" style={{ fontWeight: "bold" }}>
                {formatDate(data.issueDate)}
              </span>
              . Your collaborative efforts and outstanding performance are truly
              appreciated.
            </>
          ),
        };
      case "course_completion":
      case "training_completion":
        return {
          title:
            type === "course_completion"
              ? "Course Completion Certificate"
              : "Training Completion Certificate",
          description: (
            <>
              {type === "course_completion" ? (
                <>
                  This certifies that{" "}
                  <span className="font-bold" style={{ fontWeight: "bold" }}>
                    {data.recipientName || "[Recipient's Name]"}
                  </span>{" "}
                  has successfully completed the{" "}
                  <span className="font-bold" style={{ fontWeight: "bold" }}>
                    {data.courseName || "[Course Name]"}
                  </span>{" "}
                  at{" "}
                  <span className="font-bold" style={{ fontWeight: "bold" }}>
                    {data.companyName || "Elbert Technology "}
                  </span>{" "}
                  from{" "}
                  <span className="font-bold" style={{ fontWeight: "bold" }}>
                    {data.startDate
                      ? formatDate(data.startDate)
                      : "[Start Date]"}
                  </span>{" "}
                  to{" "}
                  <span className="font-bold" style={{ fontWeight: "bold" }}>
                    {data.endDate ? formatDate(data.endDate) : "[End Date]"}
                  </span>
                  . Your dedication to acquiring new skills and your commitment
                  to professional growth have been commendable. We congratulate
                  you on this accomplishment and encourage you to continue
                  striving for excellence.
                </>
              ) : (
                <>
                  This is to certify that{" "}
                  <span className="font-bold" style={{ fontWeight: "bold" }}>
                    {data.recipientName || "[Recipient's Name]"}
                  </span>{" "}
                  has successfully completed the{" "}
                  <span className="font-bold" style={{ fontWeight: "bold" }}>
                    {data.trainingProgramName || "[Training Program Name]"}
                  </span>{" "}
                  conducted by{" "}
                  <span className="font-bold" style={{ fontWeight: "bold" }}>
                    {data.companyName || "Elbert Technology "}
                  </span>{" "}
                  from{" "}
                  <span className="font-bold" style={{ fontWeight: "bold" }}>
                    {data.startDate
                      ? formatDate(data.startDate)
                      : "[Start Date]"}
                  </span>{" "}
                  to{" "}
                  <span className="font-bold" style={{ fontWeight: "bold" }}>
                    {data.endDate ? formatDate(data.endDate) : "[End Date]"}
                  </span>
                  . Your active participation and eagerness to learn exemplify
                  the values of continuous improvement and professional
                  development.
                </>
              )}
            </>
          ),
        };

      case "most_valuable_person":
        return {
          title: "Most Valuable Person (MVP)",
          description: (
            <>
              This certifies that{" "}
              <span className="font-bold" style={{ fontWeight: "bold" }}>
                {data.recipientName || "[Recipient's Name]"}
              </span>{" "}
              has been recognized as the <strong>Most Valuable Person</strong>{" "}
              at{" "}
              <span className="font-bold" style={{ fontWeight: "bold" }}>
                {data.companyName || "Elbert Technology "}
              </span>{" "}
              from{" "}
              <span className="font-bold" style={{ fontWeight: "bold" }}>
                {formatDate(data.startDate)}
              </span>{" "}
              to{" "}
              <span className="font-bold" style={{ fontWeight: "bold" }}>
                {formatDate(data.endDate)}
              </span>
              . For demonstrating unwavering dedication, leadership qualities,
              and a proactive attitude that greatly contributed to the success
              of our team and organization. Your exemplary performance sets a
              standard for others and inspires continuous excellence.
            </>
          ),
        };

      case "leaders_choice":
        return {
          title: "Leader’s Choice Award",
          description: (
            <>
              This is to recognize{" "}
              <span className="font-bold" style={{ fontWeight: "bold" }}>
                {data.recipientName || "[Recipient's Name]"}
              </span>{" "}
              as the <strong>Leader’s Choice</strong> recipient at{" "}
              <span className="font-bold" style={{ fontWeight: "bold" }}>
                {data.companyName || "Elbert Technology "}
              </span>
              . Your exemplary leadership, vision, and dedication have earned
              the admiration of your peers and supervisors alike. Your proactive
              approach and commitment to excellence make you a role model within
              our organization.
            </>
          ),
        };

      case "great_work":
        return {
          title: "Great Work Certificate",
          description: (
            <>
              This certifies that{" "}
              <span className="font-bold" style={{ fontWeight: "bold" }}>
                {data.recipientName || "[Recipient's Name]"}
              </span>{" "}
              has delivered <strong>Great Work</strong> at{" "}
              <span className="font-bold" style={{ fontWeight: "bold" }}>
                {data.companyName || "Elbert Technology "}
              </span>
              . Your consistent high-quality performance, innovative mindset,
              and dedication have significantly contributed to our success. We
              commend your professionalism and look forward to your continued
              excellence.
            </>
          ),
        };

      case "star_of_the_month":
        return {
          title: "Star Of The Month Certificate",
          description: (
            <>
              This is to recognize{" "}
              <span className="font-bold" style={{ fontWeight: "bold" }}>
                {data.recipientName || "[Recipient's Name]"}
              </span>{" "}
              as the <strong>Star of the Month</strong> at{" "}
              <span className="font-bold" style={{ fontWeight: "bold" }}>
                {data.companyName || "Elbert Technology "}
              </span>{" "}
              from{" "}
              <span className="font-bold" style={{ fontWeight: "bold" }}>
                {formatDate(data.startDate)}
              </span>{" "}
              to{" "}
              <span className="font-bold" style={{ fontWeight: "bold" }}>
                {formatDate(data.endDate)}
              </span>
              . For demonstrating outstanding performance, initiative, and a
              positive attitude that has inspired the entire team. Your
              dedication and excellence set a benchmark for others to follow.
            </>
          ),
        };

      case "star_of_the_quarter":
        return {
          title: "Star Of The Quarter Certificate",
          description: (
            <>
              This certifies that{" "}
              <span className="font-bold" style={{ fontWeight: "bold" }}>
                {data.recipientName || "[Recipient's Name]"}
              </span>{" "}
              has been honored as the <strong>Star of the Quarter</strong> at{" "}
              <span className="font-bold" style={{ fontWeight: "bold" }}>
                {data.companyName || "Elbert Technology "}
              </span>{" "}
              from{" "}
              <span className="font-bold" style={{ fontWeight: "bold" }}>
                {formatDate(data.startDate)}
              </span>{" "}
              to{" "}
              <span className="font-bold" style={{ fontWeight: "bold" }}>
                {formatDate(data.endDate)}
              </span>
              . In acknowledgment of your exceptional contributions, leadership,
              and consistent pursuit of excellence over the past three months.
              Your efforts have been instrumental in achieving organizational
              goals.
            </>
          ),
        };

      case "star_performer":
        return {
          title: "Star Performer Certificate",
          description: (
            <>
              This is to certify that{" "}
              <span className="font-bold" style={{ fontWeight: "bold" }}>
                {data.recipientName || "[Recipient's Name]"}
              </span>{" "}
              is recognized as a <strong>Star Performer</strong> at{" "}
              <span className="font-bold" style={{ fontWeight: "bold" }}>
                {data.companyName || "Elbert Technology "}
              </span>{" "}
              from{" "}
              <span className="font-bold" style={{ fontWeight: "bold" }}>
                {formatDate(data.startDate)}
              </span>{" "}
              to{" "}
              <span className="font-bold" style={{ fontWeight: "bold" }}>
                {formatDate(data.endDate)}
              </span>
              . Your outstanding achievements, commitment to quality, and
              proactive attitude have significantly elevated our standards and
              inspired your peers.
            </>
          ),
        };

      default:
        return {
          title: "Certificate",
          description: (
            <>
              For your valued contributions at{" "}
              <span className="font-bold" style={{ fontWeight: "bold" }}>
                '{data.companyName || "Elbert Technology"}'
              </span>
              .
            </>
          ),
        };
    }
  };

  const generateAndUploadPDF = async () => {
    const element = document.getElementById("certificate");
    if (!element) {
      showErrorToast("Certificate element not found");
      return;
    }

    try {
      const images = element.querySelectorAll("img");
      const loadPromises = Array.from(images).map(
        (img) =>
          new Promise((resolve, reject) => {
            if (img.complete) resolve();
            else {
              img.onload = resolve;
              img.onerror = () =>
                reject(new Error(`Failed to load image: ${img.src}`));
            }
          })
      );
      await Promise.all(loadPromises);

      const a4WidthPx = 3508;
      const a4HeightPx = 2480;
      const scale = 2;

      const canvas = await html2canvas(element, {
        scale: scale,
        useCORS: true,
        logging: false,
        backgroundColor: "#ffffff",
        width: element.offsetWidth,
        height: element.offsetHeight,
      });

      const imgData = canvas.toDataURL("image/jpeg", 0.95);
      const pdf = new jsPDF({
        orientation: "landscape",
        unit: "mm",
        format: "a4",
        compress: true,
      });

      const pdfWidth = 297;
      const pdfHeight = 210;
      const imgWidth = canvas.width / scale;
      const imgHeight = canvas.height / scale;

      const ratio = Math.min(pdfWidth / imgWidth, pdfHeight / imgHeight);
      const scaledWidth = imgWidth * ratio;
      const scaledHeight = imgHeight * ratio;

      const xOffset = (pdfWidth - scaledWidth) / 2;
      const yOffset = (pdfHeight - scaledHeight) / 2;

      pdf.addImage(imgData, "JPEG", 0, 0, pdfWidth, pdfHeight);

      const pdfBlob = pdf.output("blob");
      const formData = new FormData();
      formData.append(
        "file",
        pdfBlob,
        `certificate_${certificateId || Date.now()}.pdf`
      );

      const response = await axios.post(
        `${uri}/fileservice/api/files/upload`,
        formData,
        {
          headers: { "Content-Type": "multipart/form-data" },
        }
      );

      if (!response.data?.id) {
        showErrorToast("Failed to upload PDF");
        return;
      }

      showSuccessToast("PDF uploaded successfully");

      const { certificateData, certificateType } = submittedData;

      const certificateDto = {
        certificateType: certificateType.toUpperCase(),
        certificateName:
          certificateData.certificateName ||
          `${certificateType.replace(/_/g, " ").toUpperCase()} Certificate`,
        companyName: certificateData.companyName || "Elbert Technology",
        email: certificateData.email || "",
        mobileNumber: certificateData.mobileNumber || "",
        certificatePdf: response.data.id,
      };

      if (certificateType === "internship") {
        Object.assign(certificateDto, {
          internName: certificateData.recipientName || "",
          courseType: certificateData.courseType || "",
          startDate: certificateData.startDate || "",
          endDate: certificateData.endDate || "",
          duration: Number(certificateData.duration) || 0,
          issuedDate: certificateData.issueDate || "",
        });
      } else if (
        certificateType === "appreciation" ||
        certificateType === "achievement"
      ) {
        Object.assign(certificateDto, {
          internName: certificateData.recipientName || "",
          department: certificateData.dept || "",
          issuedDate: certificateData.issueDate || "",
        });
      } else if (
        certificateType === "hackathon_winner" ||
        certificateType === "hackathon_participation"
      ) {
        Object.assign(certificateDto, {
          internName: certificateData.recipientName || "",
          hackathonName: certificateData.hackathonName || "",
          issuedDate: certificateData.issueDate || "",
        });
      } else if (certificateType === "best_team") {
        Object.assign(certificateDto, {
          internName: certificateData.recipientName || "",
          teamName: certificateData.teamName || "",
          issuedDate: certificateData.issueDate || "",
        });
      } else if (
        certificateType === "course_completion" ||
        certificateType === "training_completion"
      ) {
        Object.assign(certificateDto, {
          internName: certificateData.recipientName || "",
          courseName: certificateData.courseName || "",
          issuedDate: certificateData.issueDate || "",
          startDate: certificateData.startDate || "",
          endDate: certificateData.endDate || "",
        });
      } else {
        Object.assign(certificateDto, {
          internName: certificateData.recipientName || "",
          issuedDate: certificateData.issueDate || "",
          startDate: certificateData.startDate || "",
          endDate: certificateData.endDate || "",
        });
      }

      if (certificateId) {
        certificateDto.id = certificateId;
      }

      const payload = {
        certificateType: certificateType.toUpperCase(),
        certificateDto,
      };

      console.log("Final Payload:", payload);

      try {
        let apiResponse;
        if (certificateId) {
          apiResponse = await putJsonRaw(
            api.UPDATE_CERTIFICATE_BY_ID(certificateId),
            [payload]
          );
          showSuccessToast("Certificate updated successfully");
          navigate("/certificates");
        } else {
          apiResponse = await postJsonRaw(api.CREATE_CERTIFICATE, [payload]);
          showSuccessToast("Certificate created successfully");
          navigate("/certificates");
        }
      } catch (err) {
        console.error("Error saving certificate:", err);
        showErrorToast("Failed to save certificate");
      }
    } catch (error) {
      console.error("Error:", error);
      showErrorToast(`Error generating or uploading PDF: ${error.message}`);
    }
  };

  const { certificateData, certificateType } = submittedData;
  const { title, description } = getCertificateDetails(
    certificateData,
    certificateType
  );
  const recipientName = certificateData?.recipientName || "[Recipient Name]";
  const companyName = certificateData?.companyName || "Elbert Technology";
  const issueDate =
    formatDate(certificateData?.issueDate) || formatDate(new Date());

  console.log("Rendered values:", {
    recipientName,
    companyName,
    issueDate,
    description,
  });

  return (
    <div>
      <div
        id="certificate"
        className="flex items-center justify-center m-2 border border-gray-800 rounded-xl relative bg-white overflow-hidden"
        style={{
          minHeight: "120vh",
          width: "100%",
          maxWidth: "1280px",
          margin: "auto",
          position: "relative",
        }}
      >
        <img
          src={CertificateLayout}
          alt="Layout"
          style={{
            width: "100%",
          }}
        />
        <div
          className="relative z-10 text-center max-w-3xl w-full px-6 text-black"
          style={{
            position: "absolute",
            top: 200,
            left: 100,
          }}
        >
          <h1
            className="text-[10rem] mb-4"
            style={{
              fontFamily: "'Dancing Script', cursive",
              fontSize: "96px",
              paddingRight: "30px",
            }}
          >
            Certificate
          </h1>
          <h2
            className="mb-6 tracking-widest"
            style={{
              fontFamily: "'Oleo Script', cursive",
              paddingRight: "30px",
            }}
          >
            {title.toUpperCase()}
          </h2>
          <p
            className="text-lg text-gray-600 mb-4"
            style={{
              fontFamily: "'Oleo Script', cursive",
              paddingRight: "30px",
              fontSize: "15px",
            }}
          >
            This certificate is proudly presented to
          </p>
          <div
            className="text-xl font-bold text-gray-900 border-b-2 border-gray-300 w-[300px] mx-auto mb-1"
            style={{
              fontFamily: "'Dancing Script', cursive",
              fontSize: "36px",
              paddingRight: "30px",
            }}
          >
            {recipientName}
          </div>
          <hr
            className="mt-2 mb-4"
            style={{
              position: "relative",
              width: "30em",
              borderWidth: "2px",
              left: "24em",
            }}
          />
          <p
            className="text-lg text-gray-600 mb-3 font-bold"
            style={{
              fontFamily: "'Oleo Script', cursive",
              fontWeight: "bold",
              paddingRight: "30px",
            }}
          >
            From "Elbert Technology"
          </p>
          <p
            style={{
              fontFamily: "'Oleo Script', cursive",
              fontWeight: "bold",
              paddingRight: "30px",
            }}
          >
            Reg.No: U72900TG2023PTC170069
          </p>
          <p
            className="text-base text-gray-700 mb-8 px-10"
            style={{
              width: "75em",
              fontFamily: "'Oleo Script', cursive",
              fontWeight: 400,
              fontStyle: "normal",
              fontSize: "15px",
              lineHeight: "40px",
              textAlign: "center",
              color: "#000000",
              paddingRight: "25px",
            }}
          >
            {description}
          </p>

          <Row className=" ms-3">
            <Col className="mt-1">
              <p
                className="text-base font-bold text-gray-900 mt-4"
                style={{
                  fontFamily: "'Oleo Script', cursive",
                  position: "relative",
                  width: "10em",
                  fontWeight: "bold",
                }}
              >
                {issueDate}
              </p>
              <hr
                className=" mb-2 border-gray-300"
                style={{
                  position: "relative",
                  width: "10em",
                  borderWidth: "2px",
                }}
              />
              <p
                className="text-sm text-gray-500"
                style={{
                  position: "relative",
                  width: "10em",
                  borderWidth: "2px",
                  fontFamily: "'Oleo Script', cursive",
                }}
              >
                Issued Date
              </p>
            </Col>
            <Col
              className="text-right"
              style={{ position: "relative", top: 0, left: 30 }}
            >
              <img
                src={Signature}
                alt="Signature"
                style={{
                  width: "128px",
                  height: "auto",
                  marginLeft: "50px",
                  marginTop: "20px",
                }}
              />
              <hr
                className="mt-2 mb-2 border-gray-300"
                style={{
                  position: "relative",
                  width: "20em",
                  borderWidth: "2px",
                  left: "9.5em",
                }}
              />
              <p
                className="font-semibold mt-2 ms-5"
                style={{
                  fontFamily: "'Oleo Script', cursive",
                }}
              >
                Prasanthi Rangisetti, Director
              </p>
            </Col>
          </Row>
        </div>
      </div>
      <div className="text-center mt-5">
        <CustomButton
          className=""
          onClick={generateAndUploadPDF}
          text={"Generate and Upload PDF"}
        ></CustomButton>
      </div>
    </div>
  );
};

export default CertificatePreview;
